/**
 * 金额格式化
 * https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
 * @param {*} amount
 * @param {String} style 格式化时使用的样式 decimal currency percent
 * @param {String} currency 在货币格式化中使用的货币符号 CNY USD EUR
 */
const priceFormat = (amount = 0, style = 'decimal', currency = 'CNY') => {
  let amountNum = parseFloat(amount)
  amountNum = amountNum >= 0 ? amountNum : 0
  let text = ''
  try { text = amountNum.toLocaleString('zh', { minimumFractionDigits: 2, maximumFractionDigits: 8, style, currency }) } catch (error) { }
  if (!text) {
    const len = amountNum.toString().split('.')[1] ? amountNum.toString().split('.')[1].length : 2
    const fixedNum = len > 2 ? (len > 8 ? 8 : len) : 2
    text = ((style === 'currency' && currency === 'CNY') ? '￥' : '') + amountNum.toFixed(fixedNum)
  }
  return text
}
export default {
  priceFormat
}
